import type { ResponseRead } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import {
	type HoldersInfo,
	type HoldersInfoDTO,
	HoldersInfoTypes,
} from "epsm-api-types/models";
import { BaseService } from "@/services/BaseService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";
import type { IReadAllParams } from "@/services/RequestParams";

export class HoldersInfoService extends BaseService<
	HoldersInfo,
	HoldersInfoDTO
> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter(HoldersInfoTypes));
	}

	private static instance: HoldersInfoService;

	static create() {
		if (!HoldersInfoService.instance) {
			HoldersInfoService.instance = new HoldersInfoService(HttpClient.create());
		}
		return HoldersInfoService.instance;
	}

	async getData(
		ticker: string,
		params: Readonly<IReadAllParams>,
	): Promise<HoldersInfo | null> {
		const response = await this.httpClient.get<ResponseRead<HoldersInfoDTO[]>>(
			"/holders-info",
			{
				params: {
					ticker: `eq:${ticker}`,
					...this.getQueryParams(params),
				},
			},
		);

		return response.data.data
			? this.converter.fromDTO(response.data.data[0])
			: null;
	}
}
